import { Box, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

const AppInfo = () => {
    const { t } = useTranslation()

    return (
        <Box display={'flex'} flexDirection={'column'} mb={'40px'}>
            <Typography textTransform={'uppercase'} m={'auto'} fontSize={{ xs: 24, sm: 32, md: 40 }} fontWeight={600}>{t('banner.main')}</Typography>
            <Typography textTransform={'uppercase'} m={'auto'} fontSize={{ xs: 16, md: 20 }} fontWeight={600}>{t('banner.sub')}</Typography>
        </Box>
    )
}

export default AppInfo